import React from "react";
import { PromotedAdditionalServicesContent } from "@pages/BillsPage/components/PromotedAdditionalServices/PromotedAdditionalServicesContent/PromotedAdditionalServicesContent";
import { isNullOrUndefined } from "@utils/common";

export const PromotedAdditionalServices: React.FC = () => {
  const isHidden = localStorage.getItem("hideads");

  return isNullOrUndefined(isHidden) && <PromotedAdditionalServicesContent />;
};
